import { Text } from "../../../themes/userq/Text/Text";
import React from "react";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Button } from "../../../themes/userq/Button/Button";

export default function TreeSortIntroduction({ goToFirstTask, test }) {
    return (
        <div className="tester-page-wrapper tester-welcome-page-wrap task-tree-testpage-wrap">
            <div className="container inner-page-container">
                <div className="taking-test-page-height">
                    <div className="tester-screens-hold">
                        <div className="tester-selected-page-wrap">

                            <div className="selected-page-right-side">
                                <div className="selected-test-info-img">
                                    
                                        <img src={process.env.REACT_APP_URL + "img/treetest-placeholder.svg"} alt="img" className="tree-sort-image" />
    
                                </div>
                            </div>

                            <div className={`selected-page-left-side ${test.language == "ar" ? "arabic_wrapper" : ""}`}>
                                <Text type={"h1"}>
                                    {test.language == "en" ? "Tree testing" : "الاختبار الشجري"}
                                </Text>

                                <Text type={"body-text-1"} fontWeight={'medium-font'}>
                                    {test.language == "en" ?
                                        "You’ll be asked to find certain items in a list of categories. Click through the list, until you locate the place where you think the item would be found. If you make a mistake, don’t worry, you can always go back by clicking the previous category."
                                        : "سيُطلب منك البحث عن عناصر معينة في قائمة الفئات. انقر فوق القائمة حتى تحدد المكان الذي تعتقد أنه سيتم العثور فيه على العنصر. إذا أخطأت ، فلا داعي للقلق ، يمكنك دائمًا الرجوع بالنقر فوق على الفئة السابقة."}
                                </Text>


                                <div className={'remember-text'}>
                                    <Text type={"body-text-3"} fontWeight={'medium-font'}>
                                        {test.language == "en" ? "Remember, there’s no right or wrong answer here - just do what comes naturally."
                                            : "تذكر أنه لا توجد إجابة صحيحة أو خاطئة هنا - فقط لاحظ كما تفعل بشكل طبيعي."}
                                    </Text>
                                </div>

                                <div className="button-wrapper none-for-mobile">
                                    <Button
                                        size={'large'}
                                        iconRight={<Icon colorClass={"gray-50-svg"} value={test.language=="ar"?'back-arrow':'forward-arrow'} />}
                                        label={test.language == "en" ? "Let’s start" : "لنبدأ"}
                                        onClick={() => {
                                            goToFirstTask();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="button-wrapper none-for-desktop taking-test-button">
                    <Button
                        size={'large'}
                        iconRight={<Icon colorClass={"gray-50-svg"} value={test.language=="ar"?'back-arrow':'forward-arrow'} />}
                        label={test.language == "en" ? "Let’s start" : "لنبدأ"}
                        onClick={() => {
                            goToFirstTask();
                        }}
                    />
                </div>
            </div>
        </div>

    );
}